
var accordions = document.getElementsByClassName("collapisible-details-summary");
  for (var i = 0; i < accordions.length; i++) {  
    accordions[i].addEventListener("click", function() {
    var pointSelector = this.getAttribute('point_trigger');
    var img_el = document.querySelector('#'+pointSelector);
      this.classList.add("open");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
        this.classList.remove("open");
        [...img_el.parentElement.children].forEach((sib1) =>{        
            sib1.classList.remove("active");     
            });
      } else {
        // Close all open panels before opening the clicked panel
        for (var j = 0; j < accordions.length; j++) {
          var openPanel = accordions[j].nextElementSibling;
          if (openPanel.style.display === "block") {
            openPanel.style.display = "none";
            accordions[j].classList.remove("open");
            img_el.classList.remove('active'); 
            
          }
        }
        panel.style.display = "block";
        [...img_el.parentElement.children].forEach((sib1) =>{        
        sib1.classList.remove("active");     
        });
        img_el.classList.toggle('active'); 
      }
    });
  }
  let hotSpots = document.querySelectorAll(".img-htspt");
  hotSpots.forEach((hotSpot)=>{
    hotSpot.addEventListener("click", function(e) {
      var el = e.currentTarget;
      [...el.parentElement.children].forEach((sib) =>{        
        sib.classList.remove("active");     
      });
      e.currentTarget.classList.add('active');
      var dataselector = e.currentTarget.getAttribute('trigger_id');
      var elmm = document.querySelector('#'+dataselector);    
      [...elmm.parentElement.parentElement.children].forEach((sibling) =>{
        sibling.children[0].classList.remove("open");
        sibling.children[1].style.display = "none";
      });      
      elmm.classList.add("open");
      elmm.nextElementSibling.style.display = "block";
    });
  });